import { Button, MenuItem, Select } from "@mui/material";
import axios from "axios";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { baseUrl } from "../../../Config/baseUrl";
import RichTextEditorCustom from "../../../Shared/CustomRichTextEditor";
import BookMeta from "../BookMeta";

export default function AddBook() {
  const { state } = useLocation();
  const { type } = useParams();
  const [data, setData] = useState();
  const [categoryData, setCategoryData] = useState([]);
  const [subData, setSubData] = useState([]);
  const navigate = useNavigate();

  const getBook = () => {
    axios
      .get(`${baseUrl}/blog/book-api/?book_id=${state}`, {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        setData(res?.data?.data);
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  useEffect(() => {
    state && getBook();
  }, [state]);

  const formik = useFormik({
    initialValues: {
      publish_date: data?.publish_date || "",
      image: null,
      file: null,
      title: data?.title || "",
      category: data?.category || "",
      sub_category: data?.sub_category || "",
      content: data?.content || "",
      status: data?.status || "",

      meta_title: data?.meta_title || "",
      meta_tag: data?.meta_tag || "",
      keyword: data?.keyword || "",
      meta_description: data?.meta_description || "",
      canonical: data?.canonical || "",
      og_title: data?.og_title || "",
      og_image: null,
      og_discription: data?.og_discription || "",
      og_type: data?.og_type || "",
      og_sitename: data?.og_sitename || "",
      og_url: data?.og_url || "",
      twitter_card: data?.twitter_card || "",
      twitter_description: data?.twitter_description || "",
      twitter_image: null,
      alternate: data?.alternate || "",
      robots_txt: data?.robots_txt || "",
      schema: data?.schema || " ",
      og_locale: data?.og_locale || "",
      fb_admin: data?.fb_admin || "",
      twitter_title: data?.twitter_title || "",
      twitter_site: data?.twitter_site || " ",
      url: data?.url || " ",
      lang: data?.lang || " ",
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      const reqbody = new FormData();
      reqbody.append("store", localStorage.getItem("store_id"));
      reqbody.append("publish_date", values.publish_date);
      reqbody.append("title", values.title);
      reqbody.append("category", values.category);
      reqbody.append("sub_category", values.sub_category);
      reqbody.append("content", values.content);
      reqbody.append("status", values.status);

      reqbody.append("meta_title", values.meta_title);
      reqbody.append("meta_tag", values.meta_tag);
      reqbody.append("keyword", values.keyword);
      reqbody.append("meta_description ", values.meta_description);
      reqbody.append("canonical ", values.canonical);
      reqbody.append("og_title ", values.og_title);
      reqbody.append("og_image", values.og_image);
      reqbody.append("og_discription ", values.og_discription);
      reqbody.append("og_type", values.og_type);
      reqbody.append("og_sitename ", values.og_sitename);
      reqbody.append("og_url ", values.og_url);
      reqbody.append("twitter_card", values.twitter_card);
      reqbody.append("twitter_description", values.twitter_description);
      reqbody.append("twitter_image ", values.twitter_image);
      reqbody.append("alternate ", values.alternate);
      reqbody.append("robots_txt ", values.robots_txt);
      reqbody.append("schema", values.schema);
      reqbody.append("og_locale", values.og_locale);
      reqbody.append("fb_admin ", values.fb_admin);
      reqbody.append("twitter_title ", values.twitter_title);
      reqbody.append("twitter_site", values.twitter_site);
      reqbody.append("url ", values.url);
      reqbody.append("lang ", values.lang);

      if (values.image) {
        reqbody.append("image", values.image);
      }
      if (values.file) {
        reqbody.append("file", values.file);
      }

      if (type === "update") {
        reqbody.append("book_id", state);
      }

      const request =
        type === "add"
          ? axios.post(`${baseUrl}/blog/book-api/`, reqbody, {
              headers: {
                Authorization: `Token ${localStorage.getItem("token")}`,
                "Content-Type": "multipart/form-data",
              },
            })
          : axios.patch(`${baseUrl}/blog/book-api/`, reqbody, {
              headers: {
                Authorization: `Token ${localStorage.getItem("token")}`,
                "Content-Type": "multipart/form-data",
              },
            });

      request
        .then((res) => {
          if (res.data.response_code === 200) {
            toast.success(res.data.message);
            navigate(-1);
          } else {
            toast.error(res.data.message);
          }
        })
        .catch(() => {
          toast.error("Something went wrong");
        });
    },
  });

  const blogData = () => {
    axios
      .get(`${baseUrl}/blog/blog-category-api/`, {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        setCategoryData(res?.data?.data || []);
      });
  };

  const blogSubCategory = (id) => {
    if (!id) return;
    axios
      .get(`${baseUrl}/blog/blog-subcategory-api/`, {
        params: { category_id: id },
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        setSubData(res?.data?.data || []);
      });
  };

  useEffect(() => {
    blogData();
  }, []);

  useEffect(() => {
    blogSubCategory(formik.values.category);
  }, [formik.values.category]);

  return (
    <div className="w-full min-h-screen px-4 py-6">
      <div className="max-w-6xl mx-auto bg-white shadow-lg rounded-lg">
        <form onSubmit={formik.handleSubmit} className="p-6">
          {/* Grid */}
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
            {/* Title */}
            <div>
              <p className="text-sm font-semibold">Title</p>
              <input
                id="title"
                className="w-full p-2 border border-gray-300 rounded"
                onChange={formik.handleChange}
                value={formik.values.title}
              />
            </div>

            {/* Publish Date */}
            <div>
              <p className="text-sm font-semibold">Publish Date</p>
              <input
                id="publish_date"
                type="date"
                className="w-full p-2 border border-gray-300 rounded"
                onChange={formik.handleChange}
                value={formik.values.publish_date}
              />
            </div>

            {/* Category */}
            <div>
              <p className="text-sm font-semibold">Category</p>
              <Select
                fullWidth
                value={formik.values.category || ""}
                onChange={(e) =>
                  formik.setFieldValue("category", e.target.value)
                }
              >
                {categoryData.map((cat) => (
                  <MenuItem key={cat.id} value={cat.id}>
                    {cat.name}
                  </MenuItem>
                ))}
              </Select>
            </div>

            {/* Sub Category */}
            <div>
              <p className="text-sm font-semibold">Sub Category</p>
              <Select
                fullWidth
                value={formik.values.sub_category || ""}
                onChange={(e) =>
                  formik.setFieldValue("sub_category", e.target.value)
                }
              >
                <MenuItem value="">Select sub category</MenuItem>
                {subData.map((cat) => (
                  <MenuItem key={cat.id} value={cat.id}>
                    {cat.name}
                  </MenuItem>
                ))}
              </Select>
            </div>

            {/* Status */}
            <div>
              <p className="text-sm font-semibold">Status</p>
              <select
                className="w-full p-2 border border-gray-300 rounded"
                id="status"
                value={formik.values.status}
                onChange={formik.handleChange}
              >
                <option value="">Select Status</option>
                <option value="Publish">Publish</option>
                <option value="Draft">Draft</option>
              </select>
            </div>

            {/* Image */}
            <div>
              <p className="text-sm font-semibold">Thumbnail</p>
              <input
                type="file"
                className="w-full p-2 border border-gray-300 rounded"
                onChange={(e) =>
                  formik.setFieldValue("image", e.target.files[0])
                }
              />
            </div>

            <div>
              <p className="text-sm font-semibold">Book Pdf</p>
              <input
                type="file"
                className="w-full p-2 border border-gray-300 rounded"
                onChange={(e) =>
                  formik.setFieldValue("file", e.target.files[0])
                }
              />
            </div>
          </div>

          {/* Content */}
          <div className="mt-6">
            <p className="text-sm font-semibold">Content</p>
            <RichTextEditorCustom
              value={formik.values.content}
              onChange={(value) => formik.setFieldValue("content", value)}
            />
          </div>

          <BookMeta formik={formik} />
          {/* <BookMeta hideButton={true} /> */}
          {/* Submit */}
          <div className="flex justify-center mt-8">
            <Button type="submit" variant="contained" color="success">
              {state ? "Update" : "Add"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
